import { Injectable } from '@angular/core';
import { ServiceRouter } from '../../core/http-service-router.service';
import { Config } from '../../../config/config';
import { METHOD_TYPE } from 'src/app/constants/service.constants';
import { Observable } from 'rxjs';
import { Environment } from '../../../config/environment';

/**
 * Add Address in Scheduling appointment related services
 */
@Injectable()
export class AddAddressService {
	/**
	 * Add Address Service constructor
	 * @param serviceRouter Service router object
	 * @param config Url Configuration
	 * @param environment Environment configuration
	 */
	constructor(
		private serviceRouter: ServiceRouter,
		private config: Config,
		private environment: Environment
	) {}

	/**
	 * service call for getting states
	 */
	getStates(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.schedulingApi.getStates,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}

	/**
	 * get location based on state, zip, procedure id and sub procedures id
	 * @param url - Url will contain all the necessary information like
	 * state, zip, procedure id and sub procedures id as query params
	 */
	findLocation(queryParam): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.schedulingApi.getAlternateLocations + queryParam,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}
}
